import styled from '@emotion/styled';
import { theme, media, pxToRem } from '@vfit/shared/themes';

export const ConnectionCardsContainer = styled.div`
  display: block;

  .swiper-wrapper {
    height: inherit;
  }

  ${media.tablet`
    display: flex;
    flex-direction: row;
    justify-content: center;
    margin-bottom: 45px;
  `}

  ${media.bigDesktop`
    display: flex;
    flex-direction: row;
    justify-content: center;
    margin-bottom: 120px;
  `}
`;

export const ConnectionCardsProduct = styled.div`
  margin-right: 26px;

  ${media.desktop`
    margin-right: ${theme.spacing.xl};
  `}
`;

export const ConnectionCardsText = styled.div`
  div {
    text-align: center;
  }

  ${media.tablet`
    div {
      text-align: center;
    }
  `}

  ${media.desktop`
    div {
      margin-left: 80px;
      text-align: left;
    }
  `}
`;

export const DisclaimerContainer = styled.div`
  font-family: ${theme.typography.fontFamily.primary};
  font-weight: ${theme.typography.fontWeight.bold};
  color: ${theme.colors.text.secondary};

  img {
    width: 18px;
  }
`;

export const TopTextDiv = styled.div`
  text-align: center;
  margin: ${theme.spacing['2xl']} 23px 31px 23px;
  font-family: ${theme.typography.fontFamily.primary};
  font-size: ${theme.typography.fontSize.h4};
  line-height: ${theme.typography.lineHeight.h3};
  font-weight: ${theme.typography.fontWeight.light};

  ${media.tablet`
    font-size: ${theme.typography.fontSize.display4};
    line-height: ${theme.typography.lineHeight.body2};
  `}

  b {
    font-family: ${theme.typography.fontFamily.primary};
    font-weight: ${theme.typography.fontWeight.extrabold};
  }

  img {
    cursor: text;
    vertical-align: baseline;
  }

  a {
    color: ${theme.colors.text.primary};
    font-weight: ${theme.typography.fontWeight.bold};

    &:hover {
      color: ${theme.colors.text.error};
    }
  }
`;

export const DescriptionTextDiv = styled.div`
  text-align: center;
  margin: ${theme.spacing['2xl']} 23px 31px 23px;
  font-family: ${theme.typography.fontFamily.primary};
  font-size: ${theme.typography.fontSize.h4};
  line-height: ${theme.typography.lineHeight.h4};

  ${media.tablet`
    font-size: ${theme.typography.fontSize.h2};
    line-height: ${theme.typography.lineHeight.body2};
  `}

  b {
    font-family: ${theme.typography.fontFamily.primary};
    font-weight: ${theme.typography.fontWeight.regular};
  }

  img {
    cursor: text;
    vertical-align: baseline;
  }

  a {
    color: ${theme.colors.text.primary};
    font-weight: ${theme.typography.fontWeight.bold};

    &:hover {
      color: ${theme.colors.text.error};
    }
  }
`;

export const DisclaimerTextDiv = styled.div`
  text-align: left;
  font-family: ${theme.typography.fontFamily.primary};
  font-size: ${theme.typography.fontSize.body2};
  line-height: ${theme.typography.lineHeight.body2};
  margin-left: ${pxToRem(theme.spacing.lg)};

  ${media.tablet`
      margin-left: ${pxToRem(theme.spacing.xl)};
  `}

  ${media.largeDesktop`
      margin-left: ${pxToRem(80)};
  `}

  b {
    font-family: ${theme.typography.fontFamily.primary};
    font-weight: ${theme.typography.fontWeight.extrabold};
  }

  img {
    cursor: text;
    vertical-align: baseline;
  }

  a {
    color: ${theme.colors.text.primary};
    font-weight: ${theme.typography.fontWeight.bold};

    &:hover {
      color: ${theme.colors.text.error};
    }
  }
`;

